import './style/index.js';

import _Popconfirm from './popconfirm';

export * from './type';
export type { PopconfirmProps } from './popconfirm';

export const Popconfirm = _Popconfirm;
export default Popconfirm;
